import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { cleanObj } from '../../../../../../shared/utils/objects';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import { useEffect, useState } from 'react';
import { asyncGetParams } from '../../../../../../services/param.service';
import { AlertsStatusProps } from './props';
import { AlertsStatus } from '../../../../../../shared/types/legalProceedings/alerts';

export const useAlertsStatus = ({
    data,
    onChangeData,
    onChangeFormik,
    isEdit,
}: AlertsStatusProps) => {
    const [typesStatus, setTypesStatus] = useState<ISelect[]>([]);

    const onSubmit = (data: AlertsStatus) => {
        if (onChangeData) onChangeData(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('nameAlert', data?.nameAlert || '');
        formik?.setFieldValue('active', data?.active || true);
        formik?.setFieldValue('newPqrStatus', data?.newPqrStatus || '');
        formik?.setFieldValue('observation', data?.observation || '');
    }, [data]);

    useEffect(() => {
        asyncGetParams(ParamEnum.PQR_STATUS).then((params) =>
            setTypesStatus(params)
        );
    }, []);

    return {
        formik,
        typesStatus,
        isEdit,
    };
};
